import { render, staticRenderFns } from "./MarkMusicGather.vue?vue&type=template&id=0c3ac68b&scoped=true&"
import script from "./MarkMusicGather.vue?vue&type=script&lang=js&"
export * from "./MarkMusicGather.vue?vue&type=script&lang=js&"
import style0 from "./MarkMusicGather.vue?vue&type=style&index=0&id=0c3ac68b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ac68b",
  null
  
)

export default component.exports